
export const mapMeetings = meetings => {
  return meetings.map(meeting => {
    return {
      /* ExternalMeetingID: meeting.externalIDs[0].id,
      Races: mapRaces(meeting.races, meeting) */
      ...meeting,
      ExternalMeetingID: meeting.externalIDs[0].id,
      MeetingID: meeting.id,
      meetingName: meeting.track.name,
      meetingCountry: meeting.track.country,
      meetingType: meeting.type,
      Races: mapRaces(meeting.races, meeting)
    }
  })
}

export const mapRaces = (races, meeting) => {
  return races.map(race => {
    return {
      ...race,
      Distance: { Metres: race.distance },
      Name: race.name,
      Number: race.number,
      meeting: {
        ...meeting,
        ExternalMeetingID: meeting.externalIDs[0].id
      }
      /* Competitors: race.competitors,
      Distance: { Metres: race.distance },
      Name: race.name,
      Number: race.number,
      RaceID: race.id,
      Status: race.status,
      TrackCondition: race.trackCondition,
      StartTime: race.startTime,
      meeting: {
        ExternalMeetingID: meeting.externalIDs[0].id,
        MeetingID: meeting.id,
        MeetingType: meeting.type,
        Track: {
          Name: meeting.track.name,
          Country: meeting.track.country
        }
      } */
    }
  })
}

export const mapRace = race => {
  return {
    ...race,
    meeting: {
      ...race.meeting,
      ExternalMeetingID: race.meeting.externalIDs[0].id
    }
    /* Competitors: race.competitors,
    Distance: { Metres: race.distance },
    Name: race.name,
    Number: race.number,
    RaceID: race.id,
    Status: race.status,
    TrackCondition: race.trackCondition,
    StartTime: race.startTime,
    meeting: {
      ExternalMeetingID: race.meeting.externalIDs[0].id,
      MeetingID: race.meeting.id,
      MeetingType: race.meeting.type,
      Track: {
        Name: race.meeting.track.name,
        Country: race.meeting.track.country
      }
    } */
  }
}
